import React from "react";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";

export function useTabIndicationSaveIndicacionColumns(
  deleteInsumoRow = null,
  isEditing = false
) {
  const initialColumns = [
    ...(deleteInsumoRow
      ? [
          {
            field: "action",
            headerName: "",
            flex: 1.3,
            renderCell: (cellProps) => {
              const { row } = cellProps;
              return (
                <DeleteOutlinedIcon
                  className="edit-icon"
                  onClick={() => deleteInsumoRow(row.idInsumoN)}
                />
              );
            },
          },
        ]
      : []),
    ...(isEditing
      ? [
          { field: "", headerName: "", flex: 0.1 },
          {
            field: "idIndicacion",
            headerName: "Indicación",
            flex: 3,
          },
        ]
      : []),
    {
      flex: 3,
      field: "idInsumoN",
      headerName: "ID insumo",
    },
    {
      flex: 7,
      field: "insumo",
      headerName: "Insumo",
    },
    {
      flex: 2.2,
      field: "cantidad",
      headerName: "Cantidad",
    },
    {
      flex: 2.2,
      field: "unidad",
      headerName: "Unidad",
    },
  ];

  const columns = generateColumnsDefaultConfiguration(initialColumns, true);

  return columns;
}
